<template>
  <div class="toggle-container">
    <label v-if="label" class="toggle-label">
      {{ label }}
    </label>
    <label class="switch">
      <input
        type="checkbox"
        id="rex-toggle-curvey"
        v-model="checked"
        @click="clickHandler()"
      />
      <span class="slider round"></span>
    </label>
  </div>
</template>
<script>
export default {
  name: 'RexToggleCurvey',

  props: {
    defaultValue: { type: Boolean, default: false },
    label: { type: String, required: false },
  },
  data() {
    return {
      checked: this.defaultValue,
    };
  },
  methods: {
    clickHandler() {
      this.$emit('valueChanged', !this.checked);
    },
  },
  watch: {
    defaultValue: function (newVal) {
      this.checked = newVal;
    },
  },
};
</script>
<style lang="scss" scoped>
label {
  padding: 0px;
  margin: 0px;
}

.toggle-label {
  color: $color-white;
  font-weight: bold;
  margin-left: 1rem;
  margin-right: 1rem;
  font-size: 1.25rem;
  min-width: 15rem;
}

.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 16px;
}
.toggle-container {
  align-content: center;
  display: flex;
  align-items: center;
}
/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $color-black;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 20px;
  width: 20px;
  left: 4px;
  bottom: -2px;
  background-color: $slider-before-color;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: $slider-checked-color;
}

input:focus + .slider {
  box-shadow: 0 0 1px $color-black;
}

input:checked + .slider:before {
  -webkit-transform: translateX(16px);
  -ms-transform: translateX(16px);
  transform: translateX(16px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 17px;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
